import type { ReminderSupport } from "../hooks/useReminderPrefs";
import {
  installGuidance,
  type ReminderGuidance as Guidance,
  unblockGuidance,
  updateGuidance,
} from "../lib/reminderGuidance";
import type { DeviceInfo } from "../lib/reminders";

/** The guidance for a `support` state that needs the person to do
 * something first, or `null` when there's nothing to explain. */
export function guidanceFor(support: ReminderSupport, device: DeviceInfo): Guidance | null {
  if (support === "needs_install") return installGuidance(device);
  if (support === "needs_update") return updateGuidance(device);
  if (support === "denied") return unblockGuidance(device);
  return null;
}

export interface ReminderGuidanceProps {
  guidance: Guidance;
}

/** Numbered, plain-language steps — shared by the More/Settings reminders
 * row and the Today opt-in card so both always say the same thing. */
export function ReminderGuidance({ guidance }: ReminderGuidanceProps) {
  return (
    <div class="reminder-guidance">
      <p class="reminder-guidance-intro">{guidance.intro}</p>
      <ol class="reminder-guidance-steps">
        {guidance.steps.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ol>
    </div>
  );
}
